<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('order_expense_item') || '费用填报明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:expense="{ row }">
        <expense-select
          v-model="row.expenseCode"
          filterable
          clearable
          :body="{ expenseBizType: 'O' }"
          @change="
            (value, item) => expenseChange({ val: { value, item }, row })
          "
          size="mini"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:customer="{ row }">
        <dict-select
          v-model="row.custCode"
          :selectedLabel.sync="row.custName"
          url="/master/common/dict/customerSelect"
          filterable
          clearable
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        ></dict-select>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
        />
      </template>
      <template v-slot:depCode="{ row }">
        <dep-cascader
          size="small"
          ref="dep"
          :lastValue.sync="row.depCode"
          :valueString.sync="row.displayDepCode"
          :pathLabels.sync="row.orgDepFullName"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        />
      </template>
      <template v-slot:substituteInvoice="{ row }">
        <el-checkbox
          @change="(e) => substituteInvoiceChange({ row, value: e })"
          size="mini"
        >
          {{ $l('table_value_substituteInvoice') || '是/否' }}
        </el-checkbox>
      </template>
      <template v-slot:substituteInvoiceShow="{ row }">
        <el-checkbox
          :checked="row.substituteInvoice === '0' ? true : false"
          size="mini"
        >
          {{ $l('table_value_substituteInvoice') || '是/否' }}
        </el-checkbox>
      </template>
      <template v-slot:originalExpenseType="{ row }">
        <dict-select
          v-model="row.originalExpenseType"
          :disabled="row.substituteInvoice === '1' || !row.substituteInvoice"
          :selectedLabel.sync="row.v_originalExpenseType"
          url="/master/common/dict/biz"
          :body="{ dictType: 'expenseType' }"
          filterable
          clearable
          size="mini"
        ></dict-select>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderSelect from '@/views/factory/components/order-select'
import tableColumns from './table-columns'
import { add, divideRound, multiply } from '@/libs/util.number.js'
export default {
  components: { OrderSelect },
  props: {
    disabled: { type: Boolean, default: false },
    orderExpenseCode: { type: String, default: '' },
    depCode: { type: String, default: '' },
    orgDepFullName: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        currencyAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_currency_amount_must_be_greater_than_0') ||
              '费用金额须大于0',
          },
        ],
        expenseName: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('form_placeholder_expenseType') || '请选择项目费用',
          },
        ],
        contractAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_contract_amount_must_be_greater_than_0') ||
              '合同总金额须大于0',
          },
        ],
        custName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择费用客户',
          },
        ],
        custOrderNo: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择订单编号',
          },
        ],
        orgDepFullName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择分摊部门',
          },
        ],
        v_originalExpenseType: [
          {
            validator: ({ row, cellValue }) => {
              const { substituteInvoice } = row
              if (substituteInvoice === '0' && !cellValue) {
                return new Error(
                  this.$l('table_placeholder_originalExpenseType') ||
                    '请选择代开发票的原始费用项目'
                )
              }
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.orderExpenseCode) return
      this.$api
        .orderExpenseItemListApi({ orderExpenseCode: this.orderExpenseCode })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        { depCode: this.depCode, orgDepFullName: this.orgDepFullName },
        -1
      )
      await $itemTable.setActiveCell(newRow, 'currencyAmount')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      data.forEach((t) => {
        t.paymentRatio = divideRound(t.currencyAmount, t.contractAmount, 2)
        t.v_paymentRatio = multiply(t.paymentRatio, 100) + '%'
      })
      this.$emit('updateTotAmount', totAmount)
    },
    expenseChange({ val, row }) {
      const { item } = val || {}
      const { expenseCode, expenseName, expenseType, v_expenseType } =
        item || {}
      row.expenseCode = expenseCode
      row.expenseName = expenseName
      row.expenseType = expenseType
      row.expenseTypeText = v_expenseType
    },
    substituteInvoiceChange({ row, value }) {
      row.substituteInvoice = value ? '0' : '1'
      row.originalExpenseType = ''
      row.v_originalExpenseType = ''
    },
  },
}
</script>
